let React = require('react');

//import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

let TableHeader = React.createClass({
    render: function() {
        return (
            <thead>
                <tr>
                    <th>
                        <label>Nº</label>
                    </th>
                    <th>
                        <label>NOMBRE</label>
                    </th>
                    <th>
                        <label>TIPO</label>
                    </th>
                    <th>
                        <label>LIMITE</label>
                    </th>
                    <th>
                    </th>
                    <th>
                    </th>
                </tr>
            </thead >
        );
    }
});

export default TableHeader